import PropTypes from 'prop-types';
import React from 'react';
import {
  SimpleSelectField,
} from '@unite-us/app-components';
import { ORG_CASE } from 'src/components/Cases/constants';
import { networkOptions } from 'src/components/Cases/utils';
import {
  findBySelectedId,
  propagateSelectBlur,
  propagateSelectChange,
  resolveFieldError,
  resolveSelectedValue,
} from './selectFieldHelpers';

const CaseNetworkField = ({
  caseType,
  networks,
  input,
  meta,
  onChange,
  ...props
}) => {
  const options = React.useMemo(
    () => networkOptions(networks).map((network) => ({
      value: String(network.id),
      label: network.name,
    })),
    [networks],
  );

  const value = React.useMemo(
    () => resolveSelectedValue(input?.value),
    [input?.value],
  );

  const inputRef = React.useRef(input);
  React.useEffect(() => {
    inputRef.current = input;
  }, [input]);

  const handleChange = React.useCallback((selectedId) => {
    const selectedNetwork = selectedId ? findBySelectedId(networks, selectedId) : null;
    propagateSelectChange({ inputRef, onChange, value: selectedNetwork });
  }, [networks, onChange]);

  const handleBlur = React.useCallback(
    () => propagateSelectBlur(inputRef),
    [],
  );

  return (
    <SimpleSelectField
      className={caseType === ORG_CASE ? 'hidden' : ''}
      options={options}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      required={caseType !== ORG_CASE}
      searchable
      clearable={false}
      error={resolveFieldError(meta)}
      {...props}
    />
  );
};

CaseNetworkField.propTypes = {
  disabled: PropTypes.bool,
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  networks: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  caseType: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  id: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

CaseNetworkField.defaultProps = {
  id: 'network',
  label: 'Network',
  placeholder: 'Choose one...',
  disabled: false,
  meta: undefined,
  onChange: undefined,
  caseType: undefined,
};

export default CaseNetworkField;
